import { ResourceType, Resource, StoreInterface } from '../../../../../graphql'
import { isResourceWithEntity } from '../../components/ResourcePicker'

export type LabeledResource = Resource & {
	label: string,
}

export function buildLabel( resource: Resource ): string {
	if ( !isResourceWithEntity( resource ) ) {
		return ''
	}

	if ( resource.resourceType === ResourceType.Store && ( resource.entity as StoreInterface ).parent ) {
		return `${resource.resourceType}: ${( resource.entity as StoreInterface ).parent?.name} -> ${resource.entity.name}`
	}

	return `${resource.resourceType}: ${resource.entity.name}`
}

export function appendResourceLabels( resources: Resource[] ): LabeledResource[] {
	return resources?.map( ( resource ) => ( { ...resource, label: buildLabel( resource ) } ) )
}
